import { FormText, FormSection, FormInputGroup } from 'components/form';
import {
    Typography,
    Box,
    ListItem,
    List,
    ListItemText,
    ListItemIcon,
} from '@mui/material';
import { Speed, PropaneTank } from '@mui/icons-material';
import styles from './LevelCheck.module.scss';
import { useEffect } from 'react';
import { useFormState } from 'hooks/useFormState';

export function CreateDeviceModalLevelCheckSection() {
    const formSectionTitle = 'Level Check';
    // Manage the submit button state
    const { setIsFormSubmitDisabled, currentFormSectionIndex, formSections } =
        useFormState();
    useEffect(() => {
        if (
            currentFormSectionIndex === formSections.indexOf(formSectionTitle)
        ) {
            setIsFormSubmitDisabled(false);
        }
    }, [setIsFormSubmitDisabled, currentFormSectionIndex, formSections]);

    return (
        <FormSection title={formSectionTitle}>
            <Typography variant="h6">
                Enter the tank % located on the dial
            </Typography>
            <FormInputGroup>
                <FormText
                    field="estimatedTankLevelPct"
                    label="Tank %"
                    isNumber
                />
            </FormInputGroup>
            <Box className={styles.bestPractice}>
                <Typography variant="h6" className={styles.bestPracticeHeader}>
                    Best Practice
                </Typography>
                <List>
                    <ListItem>
                        <ListItemIcon>
                            <Speed color="info" />
                        </ListItemIcon>
                        <ListItemText>
                            Ensure the dial installed is Remote Ready, R3D.
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <PropaneTank color="info" />
                        </ListItemIcon>
                        <ListItemText>
                            The type of dial should match the orientation of the
                            tank.
                        </ListItemText>
                    </ListItem>
                </List>
            </Box>
        </FormSection>
    );
}
